import React from 'react';
import s from './link.scss';
import classNames from 'classnames/bind';
var cx = classNames.bind(s);

var Link = function Link(props) {
  var children = props.children,
      className = props.className,
      onClick = props.onClick,
      dataAid = props.dataAid;
  return /*#__PURE__*/React.createElement("span", {
    onClick: onClick,
    className: cx('container', className, s.madeForFont),
    "data-aid": dataAid
  }, children);
};

export default Link;